export function cls(...classnames: any) {
  return classnames.filter(Boolean).join(" ");
}
